import { getValueCookie, validateParams } from './httpUtils';
import { hasCameraPermissions } from './functions';
import { mobileDomain } from '../Constants/Constants';
import { v4 as uuidv4 } from 'uuid';

export const checkTermsAndConditions = async context => {
  return { showTyC: !context.showTermsAndConditions };
};

export const checkCameraPermissions = async () => hasCameraPermissions();

export const checkUserState = async context => {
  return { blocked: context.blocked };
};

export const checkCustomerTransaction = async context => {
  const mismatch =
    context.customerTransaction !== context.customerTransactionUrl &&
    context.customerTransactionUrl !== null;
  return { mismatch };
};

export const validateCookie = () => async () => {
  const cookie = await getValueCookie("SSOFUB");
  const sessionId = await getValueCookie("SSNFUB");
  const dataCookie = await getValueCookie("JWEFUB");
  return { cookie, sessionId, dataCookie };
};

export const generateUrlQr = async context => {
  const url = `${mobileDomain}?clientId=${context.clientId}&data=${context.data}&SSO=${context.cookie}&session=${context.sessionId}`;
  return { resultUrl: url };
};

export const fetchValidateParameters = async context => {
  const data = await validateParams();
  if (!data.error) {
    const sessionId = data.sessionId  ?? (data.data === context.dataCookie ? context.sessionId : uuidv4());
    return {
      clientId: data.clientId,
      data: data.data,
      sessionId,
      cookie: data.cookie || context.cookie,
      customerTransaction: data.customerTransaction,
      deviceType: data.deviceType,
      isDesktopProcessInMobile: data.isDesktopProcessInMobile
    };
  }

  return { error: true };
};